export class WriteMaintenanceModeError extends Error {
  readonly errorType = 'MaintenanceMode'

  constructor() {
    super('Writes are paused for scheduled maintenance')
    this.name = 'WriteMaintenanceModeError'
  }
}

const isRecord = (value: unknown): value is Record<string, unknown> =>
  value !== null && typeof value === 'object'

export function isMaintenanceModeError(error: unknown): boolean {
  if (!isRecord(error)) return false
  if (error.errorType === 'MaintenanceMode') return true

  const nested = Array.isArray(error.errors)
    ? error.errors
    : isRecord(error.cause) && Array.isArray(error.cause.errors)
      ? error.cause.errors
      : []

  return nested.some(
    (item) =>
      isRecord(item) &&
      (item.errorType === 'MaintenanceMode' ||
        (isRecord(item.extensions) &&
          (item.extensions.errorType === 'MaintenanceMode' ||
            item.extensions.code === 'MaintenanceMode'))),
  )
}
